import AudioIcon from '../../icons/audio.svg'
import DocIcon from '../../icons/doc.svg'
import DefaultIcon from '../../icons/file.svg'
import FolderNoSystemIcon from '../../icons/folder.svg'
import FolderSystemIcon from '../../icons/folder-system.svg'
import ImageIcon from '../../icons/image.svg'
import PdfIcon from '../../icons/pdf.svg'
import PlayIcon from '../../icons/play.svg'
import PptIcon from '../../icons/ppt.svg'
import VideoIcon from '../../icons/video.svg'
import XlsIcon from '../../icons/xls.svg'

export const FileIconType = {
  Audio: 'audio',
  Default: 'default',
  Doc: 'doc',
  FolderNoSystem: 'folderNoSystem',
  FolderSystem: 'folderSystem',
  Image: 'image',
  Pdf: 'pdf',
  Play: 'play',
  Ppt: 'ppt',
  Video: 'video',
  Xls: 'xls',
}

export const FILE_ICON = {
  [FileIconType.Audio]: AudioIcon,
  [FileIconType.Default]: DefaultIcon,
  [FileIconType.Doc]: DocIcon,
  [FileIconType.FolderNoSystem]: FolderNoSystemIcon,
  [FileIconType.FolderSystem]: FolderSystemIcon,
  [FileIconType.Image]: ImageIcon,
  [FileIconType.Pdf]: PdfIcon,
  [FileIconType.Play]: PlayIcon,
  [FileIconType.Ppt]: PptIcon,
  [FileIconType.Video]: VideoIcon,
  [FileIconType.Xls]: XlsIcon,
}

export const FILE_ICON_COLOR_DOC = 'var(--color-icon-doc)'

export const FILE_ICON_COLOR_PDF = 'var(--color-icon-pdf)'

export const FILE_ICON_COLOR_XLS = 'var(--color-icon-xls)'

export const FILE_ICON_COLOR_PPT = 'var(--color-orange)'

export const FILE_ICON_COLOR_PLAY = 'var(--button-bg)'

export const FILE_ICON_COLOR = {
  [FileIconType.Doc]: FILE_ICON_COLOR_DOC,
  [FileIconType.Pdf]: FILE_ICON_COLOR_PDF,
  [FileIconType.Play]: FILE_ICON_COLOR_PLAY,
  [FileIconType.Ppt]: FILE_ICON_COLOR_PPT,
  [FileIconType.Xls]: FILE_ICON_COLOR_XLS,
}
